import { useContext, useEffect, useState } from "react"
import WorkItemConfigSideTabs from "./WorkItemConfigSideTabs"
import WorkItemStatesTable from "./workitem-states/WorkItemStatesTable"
import StateCategoriesTable from "./workitem-state-categories/WorkItemStateCategory"
import useApi from "../../hooks/useApi"
import workItemState from "../../api/WorkItemState"
import { MyContext } from "../../context/myContext"

const WorkItemConfig = () => {
    const [selectedTabKey, setSelectedTabKey] = useState<string>('0')
    const { selectedProduct } = useContext<any>(MyContext);
    const getWorkItemCategoryApi = useApi(workItemState.getWorkItemState)
    const [data,setData] =useState([])
    const handleChangeTabs = (key: string) => {
        setSelectedTabKey(key)
    }

    const getData = async () => {
        const response = await getWorkItemCategoryApi.request(selectedProduct)
        setData(response)
    }

    useEffect(()=>{
        getData()
    },[selectedProduct])
    return (
        <div className="team-config-container">
            <WorkItemConfigSideTabs selectedTabKey={selectedTabKey} handleChangeTabs={handleChangeTabs} />
            <div className="content-area mt-4">
                {selectedTabKey === '0' ? <StateCategoriesTable getData={getData} data={data} /> : <WorkItemStatesTable getData={getData} data={data} />}
            </div>
        </div>
    )
}

export default WorkItemConfig